import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {FontMaterial} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-font-material-inspector",
    templateUrl: "./font-material-inspector.component.html",
    styleUrl: "./font-material-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class FontMaterialInspectorComponent extends BaseInspectorComponent<FontMaterial, {}> {
    readonly $alignmentOptions = signal<SelectionPossibilities<FontMaterial["parameters"]["alignment"]>>([
        {value: "left", name: "Left"},
        {value: "center", name: "Center"},
        {value: "right", name: "Right"},
    ])
}
